module.exports = __webpack_public_path__ + "static/media/system-zetonowy-papierowy.6b947699.jpg";